import React, { useState, useMemo } from 'react';
import { Routes, Route } from 'react-router-dom';
import { ThemeProvider, CssBaseline, PaletteMode } from '@mui/material';
import { LoginCallback } from '@okta/okta-react';
import { createNotionTheme } from './v2/theme/notionTheme';
import DashboardV2 from './v2/DashboardV2';

function App() {
  const [mode, setMode] = useState<PaletteMode>(() => {
    const savedMode = localStorage.getItem('themeMode');
    return (savedMode as PaletteMode) || 'light';
  });

  const theme = useMemo(() => createNotionTheme(mode), [mode]);

  const toggleColorMode = () => {
    setMode((prevMode) => {
      const newMode = prevMode === 'light' ? 'dark' : 'light';
      localStorage.setItem('themeMode', newMode);
      return newMode;
    });
  };

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Routes>
        <Route path="/login/callback" element={<LoginCallback />} />
        <Route
          path="*"
          element={<DashboardV2 mode={mode} toggleColorMode={toggleColorMode} />}
        />
      </Routes>
    </ThemeProvider>
  );
}

export default App;
